import { render, staticRenderFns } from "./FlexiFundDeposit.vue?vue&type=template&id=7632908a&scoped=true&"
import script from "./FlexiFundDeposit.vue?vue&type=script&lang=js&"
export * from "./FlexiFundDeposit.vue?vue&type=script&lang=js&"
import style0 from "./FlexiFundDeposit.vue?vue&type=style&index=0&id=7632908a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7632908a",
  null
  
)

export default component.exports